{
  "title": "狀態定義參考",
  "description": "投稿與評分在不同階段的狀態定義,以及各狀態下可以做什麼。",
  "headings": ["投稿狀態", "評分狀態"],
  "intro": "以下狀態為平台實際使用的狀態,供快速查閱各狀態下可修改、可正式提交的範圍。",
  "submissionSectionHeading": "投稿狀態",
  "submissionStatusDiagram": "stateDiagram-v2\n    [*] --> Draft\n    Draft --> Ready\n    Ready --> Draft\n    Ready --> Submitted: 正式提交\n    Submitted --> Locked: 主辦方鎖定\n    Submitted --> Ready: 退回修正／解鎖\n    Locked --> Ready: 退回修正／解鎖\n    Submitted --> Withdrawn: 撤回\n    Locked --> Withdrawn: 撤回\n    Submitted --> Disqualified: 取消資格\n    Locked --> Disqualified: 取消資格",
  "submissionStatuses": [
    { "name": "Draft（草稿）", "editable": "可修改", "formalSubmit": "不可正式提交" },
    { "name": "Ready（就緒）", "editable": "可修改", "formalSubmit": "不可正式提交" },
    { "name": "Submitted（已提交）", "editable": "不可修改", "formalSubmit": "已正式提交" },
    { "name": "Locked（已鎖定）", "editable": "不可修改", "formalSubmit": "已正式提交" }
  ],
  "judgeSectionHeading": "評分狀態",
  "judgeStatuses": [
    { "name": "Assigned（已指派）", "description": "評審已被指派此作品，尚未開始評分。" },
    { "name": "Draft Score（草稿分數）", "description": "評審已儲存草稿，尚未正式送出。" },
    { "name": "Submitted（已送出）", "description": "評審已正式送出分數，隨即轉為鎖定。" },
    {
      "name": "Locked（已鎖定）",
      "description": "分數已鎖定；主辦方可視需要點選「重新開放」，回到草稿分數狀態。"
    }
  ]
}
